import {
  DeleteGallery,
  DeleteGalleryPicture,
  UpdateGallery,
} from "../../redux/gallery";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { ErrorBanner } from "../../components/banner";
import { IoTrash } from "react-icons/io5";
import { Loading } from "../../components/loader";
import { PhotoForm } from "./PhotoForm";
import { Section } from "../../components/section";
import styled from "styled-components";

export const PhotoEdits = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { loading, error } = useSelector((state) => state.gallery);

  const onFormSubmit = (values) => {
    if (window.confirm(`Are you sure you want to save your edits?`)) {
      dispatch(UpdateGallery(state.gallery.id, values));
    }

    if (!loading && !error) {
      setTimeout(() => {
        navigate("/gallery/photos");
      }, 2000);
    }
  };

  const onDeleteSubmit = () => {
    if (window.confirm(`Are you sure you want to delete this?`)) {
      dispatch(DeleteGallery(state.gallery));
    }

    if (!loading && !error) {
      setTimeout(() => {
        navigate("/gallery");
      }, 1000);
    }
  };

  const onHandleImageDelete = (mediaSource, fileName) => {
    dispatch(DeleteGalleryPicture(mediaSource, fileName));
  };

  const InitialValues = {
    ...state.gallery,
    files: state?.gallery?.media?.mediaFiles,
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <>
      <Section>
        <SubNav>
          <li onClick={onDeleteSubmit}>
            <IoTrash />
          </li>
        </SubNav>
        {error && <ErrorBanner text={error} />}

        <PhotoForm
          initialValues={InitialValues}
          onFormSubmit={onFormSubmit}
          onHandleImageDelete={onHandleImageDelete}
        />
      </Section>
    </>
  );
};

const SubNav = styled.nav`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-bottom: 2rem;

  li {
    margin-left: 1.5rem;
    display: flex;
    align-items: center;
    color: red;

    p {
      margin: 0;
      padding: 0 0 0 0.5rem;
      color: red;
    }

    &:hover {
      cursor: pointer;
    }
  }
`;
